export default __webpack_public_path__ + "static/media/NIAS0350.34I-32909_-17926_0.541cb34c.jpg";